// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"935626ef","447":"c66afa7b","453":"446179e6","552":"1657b95e","639":"097604b3"}[chunkId] + ".chunk.js";
};